/**
 * Domain Details page
 */
import React, { useState, useCallback, useEffect } from "react";

import { useSelector } from "react-redux";
import { Box } from "@material-ui/core";

import moment from "moment";

const CountDownTimer = React.memo((props) => {
  const [timeLeft, setTimeLeft] = useState({ day: "00", hour: "00", minute: "00", second: "00" });

  const { domainRenewalDetail } = useSelector((state) => ({
    domainRenewalDetail: state.domainReducer.domainRenewalDetail,
  }));

  const discountTimer = (time) => {
    const now = moment();
    const end = moment(time);
    const duration = moment.duration(end.diff(now));

    const days = Math.floor(duration.asDays());
    duration.subtract(moment.duration(days, "days"));

    // Get hours and subtract from duration
    const hours = Math.floor(duration.hours());
    duration.subtract(moment.duration(hours, "hours"));

    // Get Minutes and subtract from duration
    const minutes = Math.floor(duration.minutes());
    duration.subtract(moment.duration(minutes, "minutes"));

    // Get seconds
    const seconds = Math.floor(duration.seconds());
    const obj = {
      day: days > 0 ? days : "00",
      hour: hours > 0 ? hours : "00",
      minute: minutes,
      second: seconds,
    };

    setTimeLeft(obj);
    return;
  };

  const increment = useCallback(() => {
    props.timeLeft && discountTimer(domainRenewalDetail?.offer_expiry_date);
  }, []);

  useEffect(() => {
    const id = setInterval(increment, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <Box className="domainDetails-offer flex justify-center flex-column items-center ds-pv10">
      <div>Offer valid till</div>

      <div className="md-text16 ds-c009B45">{`${timeLeft?.day}d : ${timeLeft?.hour}h : ${timeLeft?.minute}m : ${timeLeft?.second}s`}</div>
    </Box>
  );
});

export default CountDownTimer;
